import React from "react";
import {ChevronRightIcon} from "@common/icons";

const CompressButton = props => {
    const {right, hidden, ...other} = props;

    if (hidden) {
        return null;
    }

    return (
        <div className={'ch-nav-pull-out' + (right ? '' : ' ch-nav-pull-out-l')} {...other}>
            <button className={'ch-nav-pull-out-inner'}>
                <ChevronRightIcon height={20} width={20} />
            </button>
        </div>
    )
}

const MenuCompressButton = props => {
    const { right, hidden, 'aria-controls': ariaControls, ...other} = props;

    if (hidden) {
        return null;
    }

    const isExpanded = !right;

    const buttonProps = {
        'aria-label': isExpanded ? "Compress Navigation" : "Expand Navigation",
        'aria-expanded': isExpanded,
        className: "ch-nav-menuCompress-btn",
        ...(ariaControls && { 'aria-controls': ariaControls })
    };

    return (
        <div
            className={
                "ch-nav-menuCompress" +
                (isExpanded ? " ch-nav-menuCompress-open" : "")
            }
            {...other}
        >
            <button {...buttonProps} id={'nav-menu-compress-button'}>
                <ChevronRightIcon height={20} width={20} />
            </button>
        </div>
    );
};

export {
    CompressButton,
    MenuCompressButton
};